// @ts-nocheck
import { createBrowserHistory } from 'history';
import { persistStore } from 'redux-persist';
import { middleware, reducers, sagas } from "./redux";
import { createStore } from '@/legacy/redux';
import { authProvider, dataProvider } from '@/app/providers';

export const globalStore = (function () {
  const history = createBrowserHistory();
  const refreshInterval = 1000 * 60 * 20; // 20 minutes
  const store = createStore({
    history,
    dataProvider,
    authProvider,
    locale: 'en',
    config: { auth_error_page: "/login_error", refreshInterval },
    customSagas: sagas,
    customReducers: reducers,
    customMiddleware: middleware,
  }) as any;
  let persistor = persistStore(store);
  return { store, persistor, history };
})();